import React from 'react';
import { iconMap, IconName } from './iconMap';

export type IconProps = {
  name: IconName;
  size?: number;
  color?: string;
  className?: string;
};

const Icon: React.FC<IconProps> = ({ name, size = 16, color = 'currentColor', className }) => {
  const SvgIcon = iconMap[name];

  if (!SvgIcon) {
    console.warn(`Icon with name "${name}" isn't found.`);
    return <span style={{ width: size, height: size, display: 'inline-block' }} />;
  }

  return <SvgIcon width={size} height={size} className={className} style={{ color }} aria-hidden="true" />;
};

export { Icon };
